// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zD08","title":"Header_title__1bCRw","side":"Header_side__ZoxAV"};